module.exports = __webpack_public_path__ + "34f1e7148a31f26769b19a02b85981d3.svg";